import config from '../config'

export function getTotalPrice(params) {

  let price = config.basePrice;

  for (let key in params) {
    if (params.hasOwnProperty(key) && params[key].price !== undefined) {
      if (params[key].parentAttr !== undefined && params[params[key].parentAttr].price === 0) {
        continue;
      }
      price += params[key].price;
    }
  }

  return price;

}

export function formatPrice(price, showZero = true) {

  let value = price.toFixed(2);

  if (!showZero && value % 1 === 0) {
    value = price.toFixed(0);
  }

  return value.replace('.', ',');
}

